import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  loggedInGuard,
  passwordNotExpiredGuard,
} from "./site/guards/auth.guard";
import { AppLayoutComponent } from "./layout/app.layout.component";

const routes: Routes = [
  {
    path: "",
    component: AppLayoutComponent,
    canActivate: [loggedInGuard, passwordNotExpiredGuard],
    children: [
      {
        path: "",
        data: { breadcrumb: "Home" },
        loadChildren: () =>
          import("./site/components/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: "appointments",
        data: { breadcrumb: "Appointments" },
        loadChildren: () =>
          import("./site/components/appointments/appointments.module").then(
            (m) => m.AppointmentsModule
          ),
      },
      {
        path: "schedule",
        data: { breadcrumb: "Schedule Appointment" },
        loadChildren: () =>
          import("./site/components/scheduling/scheduling.module").then(
            (m) => m.SchedulingModule
          ),
      },
      {
        path: "billing",
        data: { breadcrumb: "Billing & Payments" },
        loadChildren: () =>
          import("./site/components/billing/billing.module").then(
            (m) => m.BillingModule
          ),
        // Note: pay-copay route within billing is public (no auth guard)
        // Other billing routes inherit the parent loggedInGuard
      },
      {
        path: "insurance",
        data: { breadcrumb: "Insurance" },
        loadChildren: () =>
          import("./site/components/insurance/insurance.module").then(
            (m) => m.InsuranceModule
          ),
      },
      {
        path: "personal-info",
        data: { breadcrumb: "Personal Information" },
        loadChildren: () =>
          import(
            "./site/components/personal-info/personal-info.module"
          ).then((m) => m.PersonalInfoModule),
      },
      {
        path: "documents",
        data: { breadcrumb: "Documents" },
        loadChildren: () =>
          import("./site/components/documents/documents.module").then(
            (m) => m.DocumentsModule
          ),
      },
      {
        path: "claim/:offerId",
        data: { breadcrumb: "Claim Appointment" },
        loadChildren: () =>
          import("./site/components/claim/claim.module").then(
            (m) => m.ClaimModule
          ),
      },
    ],
  },
  {
    path: "auth",
    data: { breadcrumb: "Auth" },
    loadChildren: () =>
      import("./site/components/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    // Public payment routes (outside authenticated area)
    path: "pay",
    component: AppLayoutComponent,
    loadChildren: () =>
      import("./site/components/billing/billing.module").then(
        (m) => m.BillingModule
      ),
  },
  {
    // Public receipt viewing route (outside authenticated area)
    path: "receipt",
    component: AppLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./site/components/billing/billing.module").then(
            (m) => m.BillingModule
          ),
      },
    ],
  },
  {
    // Legal pages (accessible to everyone)
    path: "legal",
    component: AppLayoutComponent,
    data: { breadcrumb: "Legal" },
    loadChildren: () =>
      import("./site/components/legal/legal.module").then((m) => m.LegalModule),
  },
  {
    // Intake link-patient page — requires login but no password-expiry gate
    path: "link-patient",
    component: AppLayoutComponent,
    canActivate: [loggedInGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./site/components/auth/link-patient/link-patient.module").then(
            (m) => m.LinkPatientModule
          ),
      },
    ],
  },
  { path: "**", redirectTo: "" },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
